<template>
    <navigation />

    <div class="container mt-4">

        <full-series-list />

    </div>

    <site-footer />
</template>

<script>
import Navigation from "../../partials/Navigation.vue";
import SiteFooter from "../../partials/SiteFooter.vue";
import FullSeriesList from "../../partials/subscriber/FullSeriesList.vue";
import axios from "axios";

export default {
    name: "SubscriberHome",

    components: {
        FullSeriesList,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("series.title")}`,
        };
    },
};
</script>
